// MarginDropZone.jsx - Container with drag/drop logic
import { DropTarget } from 'react-dnd';
import React from 'react';
import { DragItemTypes } from 'constants/DragConstants';
import { calculateMarginPosition } from 'utils/calculateMarginPosition';
import MarginDropLine from './MarginDropLine';

const codeTarget = {
  drop(props, monitor) {
    const item = monitor.getItem();
    const didDrop = monitor.didDrop();

    if (!didDrop) {
      const marginRules = calculateMarginPosition(props, item, true);
      
      if (marginRules.canDropOnMargin) {
        if (!marginRules.marginNoOp && props.nestCodes) {
          props.nestCodes(
            item.codeID,
            marginRules.marginDropCodeId,
            marginRules.marginDropPosition
          );
          props.endDrag();
        }
      } else if (props.rejectNesting && !props.ghost) {
        props.rejectNesting();
      }
    }
  }
};

function collectTarget(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver({ shallow: true }),
    draggedItem: monitor.getItem(),
  };
}

function MarginDropZone(props) {
  const { connectDropTarget, isOver, draggedItem, isOverBottom } = props;
  
  // Calculate drop properties based on the three different states
  let depth, canDrop, isHovering;

  if (isOverBottom) {
    depth = 0;
    canDrop = true;
    isHovering = true;
  } else if (props.isOverParent) {
    // isOverParent is now only true when drop is valid (validated in CodeLabelDropZone)
    depth = props.level;
    canDrop = props.canDropOnParent;
    isHovering = true;
  } else if (isOver) {
    const marginRules = calculateMarginPosition(props, draggedItem);
    depth = marginRules.marginDepth - 1;
    canDrop = marginRules.canDropOnMargin;
    isHovering = true;
  } else {
    depth = props.level;
    canDrop = false;
    isHovering = false;
  }

  const shouldShow = isHovering && (!props.ghost || canDrop);

  // Clean implementation: Always maintain a hoverable area
  return connectDropTarget(
    <div style={{ 
      minHeight: '12px',  // Always maintain hoverable area
      paddingBottom: '4px',  // Space for the drop indicator
      position: 'relative',
      width: '100%'
    }}>
      <MarginDropLine
        show={shouldShow}
        canDrop={canDrop}
        depth={depth}
      />
    </div>
  );
}

export default DropTarget(DragItemTypes.CODE_LABEL, codeTarget, collectTarget)(MarginDropZone);